var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map-container"}},[_c('div',{staticClass:"fengmap",attrs:{"id":"fengmap"}}),_c('div',{staticClass:"map2"})])}]

export { render, staticRenderFns }